import React from 'react'

const DividerCard = ({item, styles}) => {
  const coloum_value = JSON.parse(item?.coloum_value)?.coloum_value 

  return (
    <div style={{borderColor: coloum_value.color}} className={`w-full border-b `}>

    </div>
  )
}

export default DividerCard
